export function asUrlParams(values) {
  const params = new URLSearchParams();
  Object.entries(values).forEach(([key, value]) => {
    params.append(key, value);
  });
  return params;
}

export function formatCurrency(amount) {
  return amount;
}

export const ALLOWED_STUDENT_EMAIL_DOMAIN_REGEX = /^[a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?([a-zA-Z0-9_.+-]+\.edu|afi\.com|lausd\.net)$/;

export const BTS_ACCOUNT_SIGNUP = window.BTS_ACCOUNT_SIGNUP || {
  nonce: '24ac3a2ad9',
  api_url: 'http://localhost:8088/wp-admin/admin-ajax.php',
  stripe_pub_key: 'pk_live_hxRrMmINaLH4cZ47Jv9S0gRy',
  default_state: 'PA',
  enable_sms: true,
  require_address: true,
  delay_prepaid_card_validation: true,
  system_id: process.env.VUE_APP_SYSTEM_ID || 'indego',
  order_complete_html: '<div><p>Success!</p></div>',
  regions: [],
  pass_types: [
    {
      id: 2310115,
      name: '1-Ride',
      priceSubheading: '',
      displayPrice: '$1.75/30 Minutes',
      description:
        '<ul><li>All rides are $1.75 every 30 minutes</li><li>Purchase at any station, online or in the mobile app.</li></ul>',
      fees:
        '<p class="ebike"><strong>Ride an Indego electric bike</strong><br/>Extra 15&cent;/minute</p><p class="usage"><strong>Extend your ride time</strong><br/>Extra 15&cent;/minute after the first 30 minutes</p>',
      price: 1.75,
      salesTax: 0.08,
      cardDefault: null,
      isAutoRenewing: false,
      allowCash: false,
    },
    {
      id: 2310122,
      name: '24-Hour Access',
      displayPrice: '$5 to Start',
      priceSubheading: '',
      description:
        '<ul><li>All rides 30 minutes or less are free.</li><li>$1.75 per 30 minutes thereafter.</li></ul>',
      fees:
        '<p class="ebike"><strong>Ride an Indego electric bike</strong><br/>Extra 15&cent;/minute</p><p class="usage"><strong>Extend your ride time</strong><br/>Extra 15&cent;/minute after the first 60 minutes</p>',
      price: 5,
      salesTax: 0.08,
      cardDefault: null,
      allowCash: false,
      isAutoRenewing: false,
    },
    {
      id: 239,
      name: '30-Day Pass',
      displayPrice: '$17/month',
      priceSubheading: '',
      description:
        '<ul><li>All rides 30 minutes or less are free.</li><li>$1.75 per 30 minutes thereafter.</li></ul>',
      fees:
        '<p class="ebike"><strong>Ride an Indego electric bike</strong><br/>Extra 15&cent;/minute</p><p class="usage"><strong>Extend your ride time</strong><br/>Extra 15&cent;/minute after the first 60 minutes</p>',
      terms: 'Renews every 30 days. Cancel anytime.',
      price: 17,
      salesTax: 0.08,
      cardDefault: false,
      allowCash: false,
      isAutoRenewing: true,
    },
    {
      id: 2310126,
      name: '365-Day Pass',
      priceSubheading: '',
      displayPrice: '$150/year',
      description:
        '<ul><li>All rides 30 minutes or less are free.</li><li>$1.75 per 30 minutes thereafter.</li></ul>',
      fees:
        '<p class="ebike"><strong>Ride an Indego electric bike</strong><br/>Extra 5&cent;/minute</p><p class="usage"><strong>Extend your ride time</strong><br/>Extra 5&cent;/minute after the first 60 minutes</p>',
      terms: 'Renews every 30 days. Cancel anytime.',
      price: 150,
      salesTax: 0.08,
      cardDefault: null,
      allowCash: false,
      isAutoRenewing: true,
      class: 'best',
    },
    {
      visible: false,
      id: 2310133,
      name: 'Bikeshare for Business Pass',
      priceSubheading: '',
      displayPrice: '$0/year',
      description:
        '<ul><li>All rides 30 minutes or less are free.</li><li>$1.75 per 30 minutes thereafter.</li></ul>',
      fees:
        '<p class="ebike"><strong>Ride an Indego electric bike</strong><br/>Extra 5&cent;/minute</p><p class="usage"><strong>Extend your ride time</strong><br/>Extra 5&cent;/minute after the first 60 minutes</p>',
      terms: 'Renews every 30 days. Cancel anytime.',
      discountVerificationType: 'business',
      discountVerification: 123,
      price: 0,
      cardDefault: null,
      allowCash: false,
      isAutoRenewing: true,
    },
  ],
};

if (process.env.NODE_ENV === 'development') {
  BTS_ACCOUNT_SIGNUP.pass_types = BTS_ACCOUNT_SIGNUP.pass_types.concat([
    {
      visible: true,
      id: 2310131,
      name: '30-Day Reduced Fare Pass',
      displayPrice: '$5/month',
      priceSubheading: '',
      description:
        '<ul><li>All rides 30 minutes or less are free.</li><li>$1.75 per 30 minutes thereafter.</li></ul>',
      fees:
        '<h4 class="icon icon--metro-ebike">Go electric</h4>\n    <p>Unlocking fee is waived for 30-Day and 365-Day passholders.</p>\n    <h4 class="icon icon--metro-usage">Extend your ride time</h4>\n    <p>Ride for an additional $1.75 per 30 minutes after the first half hour.</p>',
      discountVerificationType: process.env.VUE_APP_DISCOUNT_VERIFICATION_TYPE || 'metro_rf',
      discountVerification: 123,
      price: 5,
      cardDefault: null,
      allowCash: false,
      isAutoRenewing: true,
      duration: 30,
    },
    {
      visible: true,
      id: 2310132,
      name: '365-Day Reduced Fare Pass',
      priceSubheading: '',
      displayPrice: '$50/year',
      description:
        '<ul><li>All rides 30 minutes or less are free.</li><li>$1.75 per 30 minutes thereafter.</li></ul>',
      fees:
        '<h4 class="icon icon--metro-ebike">Go electric</h4>\n    <p>Unlocking fee is waived for 30-Day and 365-Day passholders.</p>\n    <h4 class="icon icon--metro-usage">Extend your ride time</h4>\n    <p>Ride for an additional $1.75 per 30 minutes after the first half hour.</p>',
      discountVerificationType: process.env.VUE_APP_DISCOUNT_VERIFICATION_TYPE || 'metro_rf',
      discountVerification: 123,
      price: 50,
      cardDefault: null,
      allowCash: false,
      isAutoRenewing: true,
      duration: 365,
    },
  ]);
}

const errorMessages = {
  RegistrationNotAcceptedEula:
  'Please agree to the User Agreement to continue.',
  RegistrationFailed:
  'An error occurred processing your registration. Please try again later or contact Customer Service for assistance.',
  RequestError:
  'An error occurred sending your registration request. Please try again later or contact Customer Service for assistance.',
  MatchingUserIsBlockedDelinquent:
  'We found an account with this phone number, but it is currently on hold due to an outstanding balance. Please contact Customer Service for assistance.',
};

const genericErrors = [
  'BTSDiscountVerificationFailed',
  'BTSValidationFailed',
  'BTSInternalError',
  'RegistrationPromoCodeInvalid',
  'ProgramNotFoundForSubscriptionType',
  'SubscriptionTypeInvalid',
  'CardClassInvalid',
  'VisibleCardNumberInvalid',
];

export function getErrorMessage(errorList) {
  if (!errorList) {
    return null;
  }
  const error = errorList[0];
  if (error in errorMessages) {
    return errorMessages[error];
  }
  if (genericErrors.includes(error)) {
    return `An error occurred processing your registration (${error}). Please try again later or contact Customer Service for assistance.`;
  }
  return null;
}
